module.exports = __webpack_public_path__ + "static/Rome small-fd5097ac66f814bafa4f5e0d80140843.png";